export default __webpack_public_path__ + "static/media/img--design-8.5fd14888.jpg";